export default __webpack_public_path__ + "assets/file-name-component.d1a95077.svg";